class emt {
    constructor() {
        if (typeof window == 'undefined') return;
        this.href = location.href;
        this.testReg = /\/\/t.m.3839/i;
        this.otReg = /ot/i;
        this.isLocal = this.href.indexOf('localhost') > -1 || this.href.indexOf('192.168') > -1;
        this.isTest = this.testReg.test(this.href);
        this.isOt = this.otReg.test(this.href);
        this.isOnline = !this.isTest && !this.isOt;
    }
}
export default new emt();
